<template>
    <div class="pageMain">
        <div style="padding: 17px 0 0 30px">
            <bread-crumb class="bread"></bread-crumb>
        </div>
        <div class="main-box">
            <transition name="fade-page" mode="out-in">
             <!--   <keep-alive>
                    <router-view v-if="!$route.meta.noCache"></router-view>
                </keep-alive>
                <router-view v-if="$route.meta.noCache"></router-view>-->
                <router-view></router-view>
            </transition>
            <footer>
                <div><p>Copyright©2021 北京宸信征信有限公司</p></div>
            </footer>
        </div>

    </div>
</template>

<script>
    import SideCollapse from '@/components/SideCollapse'
    import BreadCrumb from '@/components/BreadCrumd'

    export default {
        components: {
            SideCollapse,
            BreadCrumb
        }
    }
</script>
<style scoped>
    .main-box /deep/ .el-card{
        min-height: 782px;
    }
</style>



// WEBPACK FOOTER //
// src/layout/PageMain/index.vue